<div class="product-card" (click)="openProductInNewTab(productInfo)">
    <span class="product-tag" *ngIf="productInfo?.variationsData && productInfo?.variationsData[0] && productInfo?.variationsData[0]?.regularPrice !== productInfo?.variationsData[0]?.salePrice">
        Sale
    </span>
    <!-- <span class="product-tag  feature-tag">
        Featured
    </span> -->
    <figure  class="text-center">
        <img class="product-img d-inline-block" *ngIf="productInfo?.image && productInfo?.image?.name" [src]="hostedUrl?.images + productInfo?.image?.path + productInfo?.image?.name">
        <img class="product-img d-inline-block" *ngIf="productInfo?.productImage && productInfo?.productImage[0]?.image && productInfo?.productImage[0]?.image?.name" [src]="hostedUrl?.images + productInfo?.productImage[0]?.image?.path + productInfo?.productImage[0]?.image?.name">
    </figure>
    <span  class="card-heart-icn" (click)="addToWishlist(productInfo,$event,productInfo['_id'])">
        <i class="far fa-heart" [ngStyle]="{'display':( (productInfo?.isWishlist == 0) ?'block':'none')}"  style="font-size: 22px;"></i>
        <img [ngStyle]="{'display':( productInfo?.isWishlist == 1 ?'block':'none')}" src="assets/images/heart-icn.svg" alt="">
    </span>
    <!-- <span  class="card-cart-icn" (click)="addToCart(productInfo,$event,productInfo['_id'])">
        <i class="far fa-shopping-cart" [ngStyle]="{'display':( (productInfo?.isCart != 1) ?'block':'none')}"  style="font-size: 22px;">
        </i>
        <i class="fas fa-shopping-cart" [ngStyle]="{'display':( (productInfo?.isCart == 1) ?'block':'none')}"  style="font-size: 22px;">
        </i>
    </span> -->
    <div class="card-info">
        <!-- <img [src]="hostedUrl?.images + productInfo?.iconImage[0]?.image?.path + productInfo?.iconImage[0]?.image?.name " style="width: 100px;height: 100px;"> -->
        <h6>
            {{ productInfo?.title | slice:0:50 }}
            {{ productInfo?.title?.length > 50 ? '... ' : '' }}
        </h6>
        <p class="price-wrap fontFamilyPlayFair">
                <span class="price" *ngIf="productInfo?.variationsData && productInfo?.variationsData[0] && productInfo?.variationsData[0]?.salePrice || productInfo?.variationsData && productInfo?.variationsData[0] && productInfo?.variationsData[0]?.regularPrice"> 
                    <span class="fontWeight600">$</span> 
                    {{ productInfo?.variationsData[0]?.salePrice ? productInfo?.variationsData[0]?.salePrice : productInfo?.variationsData[0]?.regularPrice}}
                </span>
                <span class="cancelprice" *ngIf="productInfo?.variationsData && productInfo?.variationsData[0] && productInfo?.variationsData[0]?.regularPrice && productInfo?.variationsData[0]?.regularPrice !== productInfo?.variationsData[0]?.salePrice">
                    <s>
                        $ {{ productInfo?.variationsData[0]?.regularPrice  ? productInfo?.variationsData[0]?.regularPrice : '00.00' }}
                    </s> 
                 </span> 
                 <span class="discount-txt" *ngIf="productInfo?.variationsData && productInfo?.variationsData[0] && productInfo?.variationsData[0]?.salePrice && productInfo?.variationsData[0]?.regularPrice && productInfo?.variationsData[0]?.regularPrice !== productInfo?.variationsData[0]?.salePrice">
                    Save
                    {{ 
                        (productInfo?.variationsData[0]?.regularPrice - productInfo?.variationsData[0]?.salePrice) 
                        | currency:'USD':'symbol':'1.2-2'
                    }} 
                    <span *ngIf="productInfo?.variationsData && productInfo?.variationsData[0]?.discPercent">
                        ({{ productInfo?.variationsData[0]?.discPercent | number:'1.2-2' }}% off)
                    </span>
                 </span>

        </p>
         <!-- <div class="marginTwo paddingOne">
            <span *ngFor="let j of productInfo?.variationsData" class="marginRightTwo">
                <i class="fa fa-circle cursorPointer colorBorder" aria-hidden="true" [style.color]="j?.color?.hexCode"></i>
            </span>
        </div> -->
         <p *ngIf="productInfo?.avgRating == 0 || productInfo?.avgRating > 0" class="starRatingInCategoryPage" style="height: 50px;">
             <ngb-rating [(rate)]="productInfo.avgRating"  [max]="5" style="pointer-events: none;">
                 <ng-template let-fill="fill" let-index="index">
                   <!-- <span class="star" [class.filled]="fill === 100">M  -->
                    <span class="star bad" [class.full]="fill === 100">
                    <span class="half bad" [style.width.%]="fill">&#9733;</span>&#9733;
                   </span>
                 </ng-template>
               </ngb-rating>
              <span class="total-review">
                   ( {{ productInfo.avgRatingCount }} ) 
              </span> 
         </p>
        <!-- <p [innerHTML]="productInfo?.fullDescription"></p> -->
    </div>         
</div>